<template>
    <m-pageframe
        title="Import Recipients"
        :color="pageframe_color"
    >
        <v-form>
            <v-card-text>

                <v-form
                    autocomplete="off"
                >
                    <v-container>
                        <v-card-title>
                            Select Your File
                        </v-card-title>

                        <v-file-input
                            v-model="excel_file"
                            show-size
                            accept=".xlsx"
                            label="Excel File (XLSX)"
                            style="padding-bottom: 15px"
                            :rules="rules"
                        />

                        <div
                            style="text-align: right"
                        >
                            <a style="text-decoration: underline;" v-on:click="onClickShowExcelFormatDialog">How to get your file in the correct format</a>
                        </div>

                        <m-excel-import-format-error
                                ref="excel-import-format-error"
                            />

                        <v-card-actions
                            style="padding-bottom: 15px"
                        >
                            <v-btn
                                v-on:click="uploadExcelFile"
                                :disabled="!can_upload_file"
                            >
                                Upload File
                            </v-btn>
                        </v-card-actions>

                        <div
                            v-if="imported_sheets != null && imported_sheets.length > 0"
                        >
                            <v-divider/>
                            <v-card-title>
                                Tell us more
                            </v-card-title>
                            <v-checkbox
                                label="This excel sheet contains a header row"
                                v-model="has_header_row"
                            />
                            <v-select
                                label="Select Sheet to Import"
                                hint="Only one Excel sheet can be imported at a time. Select the sheet from the workbook."
                                persistent-hint
                                :items="imported_sheets"
                                v-on:input="onSelectExcelSheet"
                                style="padding-bottom: 15px"
                            ></v-select>
                        </div>

                        <div
                            v-if="selected_sheet_name != null && selected_sheet_name != ''"
                        >
                            <v-divider/>

                            <v-card-title>
                                Identify Your Columns
                            </v-card-title>

                            <v-card-subtitle>
                                Incoming Recipients (First 10 Rows)
                            </v-card-subtitle>

                            <v-data-table
                                :headers="getRecipientHeaders()"
                                :items="getSampleRecipients()"
                                :items-per-page="10"
                                class="elevation-1"
                                hide-default-footer
                                style="padding-bottom: 15px"
                                :loading="excel_worksheet == null"
                                loading-text="Loading... Please wait"
                            />

                            <v-card-title>
                                Required Columns
                            </v-card-title>

                            <v-select
                                label="Select Phone Number Column"
                                :items="getRecipientHeaders()"
                                v-model="phone_number_indices"
                                v-on:input="resetBadPhoneNumberWarning"
                                :error="display_bad_phone_number_warning"
                                :persistent-hint="display_bad_phone_number_warning"
                                hint="Select a column that contains phone numbers"
                                multiple
                            />

                            <v-select
                                label="Select First Name Column"
                                :items="getRecipientHeaders()"
                                v-model="first_name_idx"
                            />

                            <v-select
                                label="Select Last Name Column"
                                :items="getRecipientHeaders()"
                                v-model="last_name_idx"
                            />

                            <v-select
                                v-for="(item, index) in this.extra_fields_indices"
                                :key="index"
                                label="Extra Field Column"
                                :items="getRecipientHeaders()"
                                v-on:input="afterUpdateExtraField($event, index)"
                                append-outer-icon="mdi-minus-circle"
                                v-on:click:append-outer="onDeleteExtraField(index)"
                            />

                            <div
                                style="text-align: right; padding-bottom: 15px"
                            >
                                <v-btn
                                    class="mx-2" dark color="primary"
                                    v-on:click="onClickAddBlankExtraField"
                                >
                                    Add Extra Column
                                </v-btn>
                            </div>

                            <v-divider/>

                            <v-btn
                                color="secondary"
                                style="margin-bottom: 15px; margin-top: 15px; margin-right: 15px"
                                v-on:click="onClickCancel"
                            >
                                Cancel Import
                            </v-btn>
                            <v-btn
                                color="primary"
                                style="margin-bottom: 15px; margin-top: 15px"
                                v-on:click="onClickProceed"
                                :disabled="shouldDisableProceed()"
                            >
                                Proceed to Preview
                            </v-btn>
                        </div>

                    </v-container>
                </v-form>
            </v-card-text>
        </v-form>
    </m-pageframe>
</template>

<script>

export default {

    data() {
        return {
            organization_id: null,
            bulk_message_id: null,
            import_id: null,
            excel_file: null,
            imported_sheets: [],
            has_header_row: true,
            selected_sheet_name: null,
            excel_worksheet: null,
            first_name_idx: null,
            last_name_idx: null,
            phone_number_indices: [],
            extra_fields_indices: [],
            display_bad_phone_number_warning: false,
        }
    },

    mounted() {
        this.organization_id = this.$route.params.organization_id;
        this.bulk_message_id = this.$route.params.bulk_message_id;
        this.import_id = this.$route.params.import_id;
    },

    methods: {

        onClickShowExcelFormatDialog()
        {
            this.$refs['excel-import-format-error'].showDialog(false);
        },                  

        onDeleteExtraField(index)
        {
            this.extra_fields_indices.splice(index,1);
        },

        onClickAddBlankExtraField()
        {
            this.extra_fields_indices.push(null);
        },

        afterUpdateExtraField(event, index)
        {
            this.extra_fields_indices[index] = event;
        },

        shouldDisableProceed()
        {
            if ( this.selected_sheet_name == null || this.selected_sheet_name == '' ) return true;

            if ( this.excel_worksheet == null || this.excel_worksheet == {} ) return true;

            if ( this.first_name_idx == null || this.last_name_idx == null || this.phone_number_indices == null || this.phone_number_indices.length == 0 ) return true;

            return false;
        },

        onSelectExcelSheet(sheet_selected)
        {
            this.selected_sheet_name = sheet_selected;

            this.$rc.listBulkRecipientImportInfo(
                this.organization_id,
                this.import_id,
                sheet_selected,
                this.has_header_row,
                (data) => {
                    
                    this.$rc.hideSpinner();

                    this.excel_worksheet = data.excel_worksheet;
                },
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert(
                        'Error Getting Import Preview',
                        'There was an error getting details about this sheet. Please try again.'
                    );
                },
            );
        },

        resetBadPhoneNumberWarning()
        {
            this.display_bad_phone_number_warning = false;
        },

        getRecipientHeaders()
        {
            if ( this.excel_worksheet == null ) return [];

            let ret = [];

            for ( let i=0; i < this.excel_worksheet.headers.length; i++ )
            {
                if ( this.excel_worksheet.headers[i].value == 'rc_row_number' ) continue;

                ret.push(this.excel_worksheet.headers[i]);
            }

            return ret;
        },

        getSampleRecipients()
        {
            if ( this.excel_worksheet == null ) return [];

            return this.excel_worksheet.data;
        },

        onClickCancel()
        {
            this.$router.push({
                'name': 'view-bulk-message',
                'params' : {
                    'organization_id' : this.organization_id,
                    'bulk_message_id' : this.bulk_message_id,
                }
            }).catch(e=>{}); // swallow any exception
        },

        onClickProceed()
        {
            this.$rc.showSpinner('Extracting data, this can take several minutes...');
            let import_definition = null;

            if ( !this.shouldDisableProceed() )
            {
                import_definition = {
                    'sheet_name' : this.selected_sheet_name,
                    'has_header_row' : this.has_header_row,
                    'first_name_idx' : this.first_name_idx,
                    'last_name_idx' : this.last_name_idx,
                    'phone_number_indices' : this.phone_number_indices,
                    'extra_fields_indices' : this.extra_fields_indices,
                };
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/bulk/recipients/update-excel-import-definition/start',
            
                'params' : {
                        'organization_id': this.organization_id,
                        'bulk_message_id': this.bulk_message_id,
                        'import_id': this.import_id,
                        'import_definition': import_definition,
                    },
            
                'on_success': (data) => {
                        let process_id = data.process_id;
                        let checks_remaining = 241; // two minute time limit, basically...

                        this.onCheckUpdateImportDefinition(process_id, checks_remaining);
                    },
            
                'on_error': 'Unable to update import definition',
            });
        },

        onCheckUpdateImportDefinition(process_id, checks_remaining)
        {
            if ( checks_remaining < 0 )
            {
                this.$rc.hideSpinner();
                this.$rc.alert('Update import failed', 'Unable to update the import paramaters.  Please try again');
                return;
            }

            checks_remaining--;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/async-process/:process_id',
            
                'params' : {
                        'process_id': process_id,
                    },
            
                'on_success': (data) => {
                        if ( data.state == 'finished' )
                        {
                            if ( data.output.state == 'finished' )
                            {
                                this.$rc.hideSpinner();

                                this.$router.push({
                                    'name': 'bulk-recipient-preview',
                                    'params' : {
                                        'organization_id' : this.organization_id,
                                        'bulk_message_id' : this.bulk_message_id,
                                        'import_id' : this.import_id,
                                    }
                                });
                            }
                            else
                            {
                                this.$rc.hideSpinner();
                        
                                this.display_bad_phone_number_warning = true;

                                this.$rc.alert(
                                    'Phone Number Error',
                                    'The selected Phone Number Column did not contain any valid phone numbers. Please select a valid column and try again.',
                                );
                            }
                        }
                        else
                        {
                            // Still running...
                            window.setTimeout(
                                () => {
                                    this.onCheckUpdateImportDefinition(process_id, checks_remaining);
                                },
                                1000
                            )
                        }
                    },
            
                'on_error': 'Unable to update the excel import process',
            });
            
        },

        uploadExcelFile()
        {
            this.$rc.showSpinner('Uploading file to servers...');

            this.$rc.uploadBulkRecipientExcelFile(
                this.organization_id,
                this.import_id,
                this.excel_file,
                this.bulk_message_id,
                (data) => 
                {
                    if ( data.state != 'finished' )
                    {
                        this.$rc.hideSpinner();

                        this.$rc.alert(
                            'Error Uploading File',
                            'There was an error uploading the recipients file, please try again',
                        );
                    }
                    else
                    {
                        this.$rc.hideSpinner();
                        this.imported_sheets = data.sheet_names; 
                    }
                },
                () => {
                    this.$rc.hideSpinner();

                    this.$rc.alert(
                        'Error Uploading File',
                        'There was an error uploading the recipients file, please try again',
                    );
                },
            );
        },

        onClickSave()
        {
            this.save();
            this.closeDialog();
        },
    },
    computed: {
        is_valid() {
            return this.excel_file != null && this.excel_file != '';
        },

        pageframe_color() {
            if ( this.$route.params.organization_id !== this.$rc.$state.organization_id )
                return '#5D647C';
            else
                return '#F24653';
        },

        rules() {
            return [
                value => !value || value.size < 5242880 || 'Excel files must be less than 5 MB',
            ];
        },

        can_upload_file() {
            if (! this.excel_file) return false;

            for (const rule of this.rules)
            {
                const result = rule(this.excel_file);
                if (result === false || typeof result === 'string') return false;
            }

            return true;
        }

    },
}
</script>

<style lang="scss" scoped>
</style>